// removed by extract-text-webpack-plugin
module.exports = {"container":"SandboxedEditorComponent__container___2-77E","loader":"SandboxedEditorComponent__loader___3xZus","executeButton":"SandboxedEditorComponent__executeButton___2vLWg"};


//////////////////
// WEBPACK FOOTER
// ./src/game/menus/SandboxedEditorComponent.scss
// module id = 167
// module chunks = 0